import { frontendURL } from '../../../helper/URLHelper';
import InternalChatPage from './pages/InternalChatPage.vue';

export const routes = [
  {
    path: frontendURL('accounts/:accountId/internal'),
    name: 'internal_rooms_index',
    component: InternalChatPage,
    meta: { permissions: ['administrator', 'agent'] },
  },
  {
    path: frontendURL('accounts/:accountId/internal/rooms/:roomId'),
    name: 'internal_room_show',
    component: InternalChatPage,
    meta: { permissions: ['administrator', 'agent'] },
  },
];
